import { useCallback, useState } from 'react'
import { Alert, Options } from './types/Alert'

const useSnapAlerts = () => {
  const [alerts, setAlerts] = useState<Alert[]>([])

  const show = useCallback((message: string, options: Options = {}) => {
    console.log('show', message, options)
  }, [])
  const hide = useCallback((id: number) => {
    console.log('hide', id)
  }, [])
  const clear = useCallback(() => setAlerts([]), [])

  return { show, hide, clear, alerts }
}

export default useSnapAlerts
